<template>
  <b-card class="card-create">
    <div class="content-img-welcome">
      <img
        class="img-welcome"
        src="https://cdn.discordapp.com/attachments/854194270033412118/887899765394784316/Asset_12x.png"
        alt=""
        draggable="false"
      />
      <div class="coming-soon-text">
        COMING SOON!
      </div>
    </div>
  </b-card>
</template>

<script>
  import { BCard } from 'bootstrap-vue';
  export default {
    components: {
      BCard,
    },
  };
</script>

<style scoped>
  .content-img-welcome {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    align-items: center;
    padding: 5vw 0;
    width: 100%;
    height: 90%;
  }

  .img-welcome {
    width: 50%;
  }

  .coming-soon-text {
    text-align: center;
    margin-top: 2rem;
    font-size: 7vw;
    color: #383856;
  }
</style>
